import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from '@/components/layout/ProtectedRoute.tsx';
import IsNotLoggedIn from '@/components/layout/IsNotLoggedIn.tsx';
import AdminRoute from '@/components/layout/AdminRoute.tsx';
import SalespersonRoute from '@/components/layout/SalespersonRoute.tsx';
import SuperUserRoute from '@/components/layout/SuperUserRoute.tsx';
import FlowLock from '@/components/layout/FlowLock.tsx';
import LandingPage from '@/pages/LandingPage.tsx';
import LoginPage from '@/pages/LoginPage.tsx';
import RegisterPage from '@/pages/RegisterPage.tsx';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.tsx';
import ResetPasswordPage from '@/pages/ResetPasswordPage.tsx';
import SalespersonDashboard from '@/pages/SalespersonDashboard.tsx';
import SimulationsPage from '@/pages/SimulationsPage.tsx';
import ProgressPage from '@/pages/ProgressPage.tsx';
import RankingPage from '@/pages/RankingPage.tsx';
import ProfilePage from '@/pages/ProfilePage.tsx';
import SimulationFormPage from '@/pages/SimulationFormPage.tsx';
import KnowledgeBookPage from '@/pages/KnowledgeBookPage.tsx';
import ManagerDashboard from '@/pages/ManagerDashboard.tsx';
import AdminSimulationsPage from '@/pages/AdminSimulationsPage.tsx';
import AdminRankingPage from '@/pages/AdminRankingPage.tsx';
import TeamManagementPage from '@/pages/TeamManagementPage.tsx';
import SimulationPage from '@/pages/SimulationPage.tsx';
import MaestroPage from '@/pages/MaestroPage.tsx';
import DataPrivacyRoute from '@/components/layout/DataPrivacyRoute.tsx';
import SuperUserDebugSessionsPage from '@/pages/SuperUserDebugSessionsPage.tsx';
import SuperUserDebugSessionDetailPage from '@/pages/SuperUserDebugSessionDetailPage.tsx';
import SuperUserAdminUsersPage from '@/pages/SuperUserAdminUsersPage.tsx';
import SuperUserCatalogPage from '@/pages/SuperUserCatalogPage.tsx';
import SuperUserCatalogEditPage from '@/pages/SuperUserCatalogEditPage.tsx';
import NotFoundPage from '@/pages/NotFoundPage.tsx';
import MvpHomePage from '@/pages/MvpHomePage.tsx';
import EvaluateFlowPage from '@/pages/EvaluateFlowPage.tsx';
import PitchFlowPage from '@/pages/PitchFlowPage.tsx';
import VerifyEmailPage from '@/pages/VerifyEmailPage.tsx';
import SuperUserScoringPage from '@/pages/SuperUserScoringPage.tsx';
import SuperUserFeedbackPage from '@/pages/SuperUserFeedbackPage.tsx';

// MVP: la home muestra siempre los dos botones (Evalúa / Crea tu pitch),
// con o sin sesión. La antigua LandingPage marketing queda en /landing.
export const router = createBrowserRouter([
  {
    path: '/',
    element: <MvpHomePage />,
  },
  {
    path: '/landing',
    element: <LandingPage />,
  },
  {
    // Verificación de email: accesible con o sin sesión (el enlace llega por correo).
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    // Privacy & términos: PÚBLICO — debe verse antes de registrarse/iniciar sesión.
    path: '/data-privacy',
    element: <DataPrivacyRoute />,
  },
  {
    element: <IsNotLoggedIn />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      { path: '/profile', element: <ProfilePage /> },
      { path: '/knowledge', element: <KnowledgeBookPage /> },
      // Simulation execution + maestro pages stay universal — Managers also run
      // simulations (testing, QuickPractice) and Salespeople run their assigned ones.
      { path: '/simulation/:id', element: <SimulationPage /> },
      { path: '/maestro/:id', element: <MaestroPage /> },
      // Flujos MVP: el usuario normal sólo accede al flujo que eligió en la home
      // (FlowLock); el SuperUser puede entrar a ambos.
      { path: '/evaluate', element: <FlowLock flow="evaluate"><EvaluateFlowPage /></FlowLock> },
      { path: '/pitch', element: <FlowLock flow="pitch"><PitchFlowPage /></FlowLock> },
      // Progress is universal — Managers also run QuickPractice sessions and need
      // access to the resulting reports / their own session history.
      { path: '/progress', element: <ProgressPage /> },
    ],
  },
  {
    element: <SalespersonRoute />,
    children: [
      { path: '/dashboard', element: <SalespersonDashboard /> },
      { path: '/simulations', element: <SimulationsPage /> },
      { path: '/ranking', element: <RankingPage /> },
    ],
  },
  {
    element: <AdminRoute />,
    children: [
      { path: '/admin', element: <ManagerDashboard /> },
      { path: '/admin/simulations', element: <AdminSimulationsPage /> },
      { path: '/admin/ranking', element: <AdminRankingPage /> },
      { path: '/team', element: <TeamManagementPage /> },
      { path: '/admin/simulations/new', element: <SimulationFormPage /> },
      { path: '/admin/simulations/edit/:id', element: <SimulationFormPage /> },
    ],
  },
  {
    element: <SuperUserRoute />,
    children: [
      { path: '/superuser/debug/sessions', element: <SuperUserDebugSessionsPage /> },
      { path: '/superuser/debug/sessions/:id', element: <SuperUserDebugSessionDetailPage /> },
      { path: '/superuser/admin/users', element: <SuperUserAdminUsersPage /> },
      { path: '/superuser/scoring', element: <SuperUserScoringPage /> },
      { path: '/superuser/feedback', element: <SuperUserFeedbackPage /> },
      { path: '/superuser/catalog', element: <SuperUserCatalogPage /> },
      { path: '/superuser/catalog/edits/:draftId', element: <SuperUserCatalogEditPage /> },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
